import React from 'react'

import { TableClaimant } from './components'

const ClaimantHistory: React.FC = () => {
  return (
    <TableClaimant />
  )
}

export default ClaimantHistory
